
import "./Loading.css";


export default function Loading(){
    return(
        <div class="screen">
        <div class="loading">

            <div class="loading-animation">

            <p>. </p><p>. </p><p>. </p></div>

        </div></div>
    );
}